import './App.css';
import superlogo from './superlogo.png'
import Routes from "./routes";
import React, { Component } from 'react';
import ReactDOM from 'react-dom'

class App extends Component {
  render() {
    return <div>
      <head>
        <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.4.1/css/bootstrap.min.css"></link>
        <script src="https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js"></script>
        <script src="https://maxcdn.bootstrapcdn.com/bootstrap/3.4.1/js/bootstrap.min.js"></script>
      </head>
      <div class="topnavhigh">
        <img src={superlogo} className="Logo" alt="logo" />
      </div>
      <div class="paragraph">
        <Routes />
      </div>
      <section id="footer">
        <div class="container">
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 mt-2 mt-sm-5">
              <ul class="list-unstyled list-inline social text-center">
                <li class="list-inline-item"><a href="https://www.facebook.com/supersonicrental"><i class="fa fa-facebook"></i></a></li>
                <li class="list-inline-item"><a href="mailto:supersonicrental@gmail.com"><i class="fa fa-envelope"></i></a></li>
              </ul>
            </div>
            <hr></hr>
          </div>
        </div>
      </section>
      <footer class="container-fluid text-center">
        <p>© 2021</p>
      </footer>
    </div>
  }
}

ReactDOM.render(<App />, document.getElementById('root'));
